import { useContext } from "react";
import { Box } from "@mui/material";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { SortArrow } from "./InvoiceList";
import { NEW_SORT } from "../../../../constants";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

export const InvListTableHeads = [
  {
    i18nKey: "date",
    isArrow: true,
    onClick: (filters, handleFilterChange) => {
      handleFilterChange(
        "sort",
        filters.sort == "Oldest" ? "Newest" : "Oldest",
      );
    },
    showDataKey: "date",
    className: "textLeft",
    bodyClassName: "newFontColor",
    columnClassName: "sidebarOption",
  },
  {
    i18nKey: "contact",
    showDataKey: "cust_name",
    className: "textLeft",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
  {
    i18nKey: "invoice_no",
    i18nKeyOut: "PO_number",
    showDataKey: "inv_num",
    className: "textLeft",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
  {
    i18nKey: "due_date",
    showDataKey: "date",
    className: "textLeft",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
  {
    i18nKey: "status",
    isArrow: true,
    onClick: (filters, handleFilterChange) => {
      handleFilterChange(
        "sort",
        filters.sort == NEW_SORT.unpaid ? NEW_SORT.paid : NEW_SORT.unpaid,
      );
    },
    showDataKey: "status",
    className: "textLeft",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
  {
    i18nKey: "amount",
    showDataKey: "amount",
    rsLabel: true,
    className: "textRight",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
  {
    i18nKey: "balance",
    showDataKey: "balance",
    rsLabel: true,
    className: "textRight",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
  {
    i18nKey: "actions",
    showActionButton: true,
    className: "textCenter",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
];

const SalePurchaseListTableHeader = ({
  filters,
  handleFilterChange,
  type,
  disabled = false,
}) => {
  const [I18n] = useContext(LanguageContext);

  const columnLabel = (headInfo) => {
    if (type === "in") {
      return I18n[headInfo.i18nKey];
    }
    if (headInfo.i18nKeyOut) {
      return I18n[headInfo.i18nKeyOut];
    }
    return I18n[headInfo.i18nKey];
  };

  return (
    <Box className="invoiceListTableHeader">
      {InvListTableHeads.map((headInfo, ind) => (
        <Box
          key={ind}
          onClick={
            headInfo.onClick && !disabled
              ? () => {
                  triggerLogEvent(analytics, "inv_list_sort", {
                    column: headInfo.showDataKey,
                    type,
                  });
                  headInfo.onClick(filters, handleFilterChange);
                }
              : undefined
          }
          className={`invListTableHeaderCol eightColumn ${headInfo.className} ${headInfo.columnClassName || ""} ${
            headInfo.onClick && !disabled ? "cursorPointer" : ""
          }`.trim()}
        >
          {(!("displayOn" in headInfo) || headInfo.displayOn === type) && (
            <ParagraphText
              className="fontSize12 fontWeight500 newLightColor"
              key={headInfo.i18nKey}
            >
              {columnLabel(headInfo)}
              {headInfo.isArrow ? (
                <SortArrow
                  id={
                    headInfo.showDataKey === "date"
                      ? type === "out"
                        ? "pb_date_sort"
                        : "sale_inv_date_sort"
                      : type === "out"
                        ? "pb_status_sort"
                        : "sale_inv_status_sort"
                  }
                  isAscending={
                    headInfo.showDataKey === "date"
                      ? filters.sort !== "Oldest"
                      : filters.sort !== NEW_SORT.unpaid
                  }
                  disabled={disabled}
                />
              ) : null}
            </ParagraphText>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default SalePurchaseListTableHeader;
